import React from 'react';
import autoBind from 'react-autobind';
import DeckGL from "deck.gl";
import {WebMercatorViewport} from 'deck.gl';
import {GeoJsonLayer, IconLayer, TripsLayer} from 'deck.gl'
import { _MapContext as MapContext, StaticMap, NavigationControl } from "react-map-gl";

import Config from "composer/Config.jsx";
import Localization from "composer/Localization.jsx"

import ButtonGroup from '@material-ui/core/ButtonGroup';

import startFlag from "composer/images/flags/start.png";
import endFlag from "composer/images/flags/end.png";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Card,
  CardContent,
  Divider,
  Typography,
  Grid,
} from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Rectangle,
  Polyline,
} from "react-google-maps";

const {KalmanFilter} = require('kalman-filter');

class SubmissionDetailMapDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      open: false,
      localeCenter: {
        lat: 22.4191,
        lng: 114.2059,
      },
      localeUpperLeft: {
        lat: 22.4299,
        lng: 114.1942,
      },
      localeBottomRight: {
        lat: 22.4083,
        lng: 114.2176,
      },
      map: {
        zoom: 0,
        center: {
          lat: 0,
          lon: 0
        },
        bounds:{
          ul:{
            lat: 0,
            lon: 0
          },
          br:{
            lat: 0,
            lon: 0
          }
        },
        style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
        _style: "cartoon",
        lang: "zh"
      },
      routeData: null,
      localeData: null,
      localeColor:this.props.theme.palette.primary.main,
      route: [],
    }
    autoBind(this);
  }

  handleClose() {
    this.setState({
      open: false
    });
    this.state.open = false;
  }

  distance(lat1, lon1, lat2, lon2, unit = "K") {
    if ((lat1 == lat2) && (lon1 == lon2)) {
      return 0;
    }
    else {
      var radlat1 = Math.PI * lat1/180;
      var radlat2 = Math.PI * lat2/180;
      var theta = lon1-lon2;
      var radtheta = Math.PI * theta/180;
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = dist * 180/Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit=="K") { dist = dist * 1.609344 }
      if (unit=="N") { dist = dist * 0.8684 }
      return dist;
    }
  }

  routeFilter(routeData){
    var routeArr = [];
    var res = [];
    if (routeData != null){
      for (let i = 0; i < routeData.length; i++){
        routeArr.push([routeData[i][0], routeData[i][1]]); 
      }
      
      //use custom filter instead of kalman filter
      //filter and average out similar coordinate
      var newRouteArr = [routeArr[0]];
      var newRouteArr_idx = 0;
      var routeArr_idx = 1;
      var dist_thresh = 0.01;
      while(routeArr_idx < routeArr.length-1){
        var dist = this.distance(newRouteArr[newRouteArr_idx][0], newRouteArr[newRouteArr_idx][1], routeArr[routeArr_idx][0], routeArr[routeArr_idx][1]);
        if(dist < dist_thresh){
          routeArr_idx += 1;
        }else{
          newRouteArr.push(routeArr[routeArr_idx]);
          newRouteArr_idx += 1;
          routeArr_idx += 1;
        }
      }
      res = newRouteArr;
    }else{
      res = routeArr;
    }
    return res;
  }

  genBoxData(){
    var boxData = []
    boxData.push({
      'type': 'Feature',
      'color': parseInt(this.state.localeColor).toString(16),
      'geometry': {
        'type': 'Polygon',
        'coordinates': [[
          [parseFloat(this.state.localeUpperLeft.lng), parseFloat(this.state.localeUpperLeft.lat)],
          [parseFloat(this.state.localeUpperLeft.lng), parseFloat(this.state.localeBottomRight.lat)],
          [parseFloat(this.state.localeBottomRight.lng), parseFloat(this.state.localeBottomRight.lat)],
          [parseFloat(this.state.localeBottomRight.lng), parseFloat(this.state.localeUpperLeft.lat)],
          [parseFloat(this.state.localeUpperLeft.lng), parseFloat(this.state.localeUpperLeft.lat)]
        ]]
      }
    });
    
    var boxLayers = new GeoJsonLayer({
        id: 'geojson-layer',
        data: boxData,
        lineWidthScale: 4,
        opacity: 0.4,
        filled: true,
        stroked: true,
        lineWidth: 2,
        lineWidthMinPixels: 2,
        wireframe: true,
        getLineColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0];
        },
        getFillColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          hex = hex + '1f';
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
        },
        pickable: true,
      });

      return boxLayers;
  }

  genRouteData(routeData, outline = false){
    // append routeArr here
    var routeArr = [];
    if (routeData != null){
      for (let i = 0; i < routeData.length; i++){
        routeArr.push([routeData[i][0], routeData[i][1]]); 
      }
    }
    
    var routeData = []
    routeData.push({
      'type': 'Feature',
      'color': parseInt(this.state.localeColor).toString(16),
      'geometry': {
        'type': 'Polygon',
        'coordinates': [routeArr]
      }
    });
    
    if (outline){
      var routeLayers = new GeoJsonLayer({
        id: 'geojson-layer',
        data: routeData,
        lineWidthScale: 2,
        opacity: 1,
        filled: false,
        stroked: true,
        lineWidth: 2,
        lineWidthMinPixels: 2,
        lineCapRounded: true,
        lineJointRounded: true,
        // wireframe: true,
        getLineColor: f => {
          return [255, 255, 255];
        },
        
        pickable: true,
      });
    }else{
      var routeLayers = new GeoJsonLayer({
        id: 'geojson-layer',
        data: routeData,
        lineWidthScale: 1,
        opacity: 0.5,
        filled: false,
        stroked: true,
        lineWidth: 2,
        lineWidthMinPixels: 2,
        lineCapRounded: true,
        lineJointRounded: true,
        // wireframe: true,
        getLineColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0];
        },
        
        pickable: true,
      });
    }

    return routeLayers
  }

  genPathLayer(){
    var routeArr = []; //list of route
    if (this.state.routeData != null){
      var route = [];
      var lastTimestamp = this.state.routeData[0][2];
      const timestampThresh = 300;
      for(let i = 0; i < this.state.routeData.length; i++){
        var timestamp = this.state.routeData[i][2];
        if((timestamp - lastTimestamp) > timestampThresh){
          // append current route and change to new route
          routeArr.push(route);
          route = [];
        }
        route.push([this.state.routeData[i][1], this.state.routeData[i][0]]);
        lastTimestamp = timestamp;
      }
      //push last route
      routeArr.push(route);

      // create route layers
      var pathLayers = [];
      for(let i = 0; i < routeArr.length; i++){
        var filtered_route = this.routeFilter(routeArr[i]);
        pathLayers.push(this.genRouteData(filtered_route, true));
        pathLayers.push(this.genRouteData(filtered_route, false));

        if(filtered_route[0][0] != filtered_route[filtered_route.length-1][0] && filtered_route[0][1] != filtered_route[filtered_route.length-1][1]){
          pathLayers.push(this.genIconLayer(true, filtered_route[0]));
          pathLayers.push(this.genIconLayer(false, filtered_route[filtered_route.length-1]));
        }
        // pathLayers.push(this.genIconLayer(true, routeArr[i][0]));
        // pathLayers.push(this.genIconLayer(false, routeArr[i][routeArr[i].length-1]));
      }

      return pathLayers;
    }else{
      return [];
    }
  }

  genIconLayer(start = true, coordinate){
    var iconData = [];
    var iconA = null;

    if (this.state.routeData != null){
      if (start){
        iconData.push({
          'color': '00ff00',
          'coordinates': coordinate,
        });
        iconA = startFlag;
      }else{
        iconData.push({
          'color': 'ff0000',
          'coordinates': coordinate,
        });
        iconA = endFlag;
      }
    }

    const ICON_MAPPING = {
      marker: {
        x: 0,
        y: 0,
        width: 80,
        height: 80,
        anchorY: 80,
        mask: true
      }
    };

    var iconLayers = new IconLayer({
      id: 'icon-layer',
      data: iconData,
      pickable: true,
      autoHighlight: false,
      iconAtlas: iconA,
      iconMapping: ICON_MAPPING,
      getIcon: d => 'marker',
  
      sizeScale: 15,
      getPosition: d => d.coordinates,
      getSize: d => 3,
      getColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
      },
    });

    return iconLayers;
  }

  setRouteData(data) {
    this.setState({ routeData: data });
    let pointArr = [];
    for(let i = 0; i < data.length; i++) {
      let point = {
        lat: data[i][0],
        lng: data[i][1],
      }
      pointArr.push(point);
    }
    this.setState({ route: pointArr });

    let localeData = this.props.root.getCurrentLocale();
    this.setState({
      localeCenter: {lat: parseFloat(localeData.mid_lat), lng: parseFloat(localeData.mid_lon)},
      localeUpperLeft: {lat: parseFloat(localeData.ul_lat), lng: parseFloat(localeData.ul_lon)},
      localeBottomRight: {lat: parseFloat(localeData.br_lat), lng: parseFloat(localeData.br_lon)},
      localeColor: localeData.color,
    });
  }

  render() {
    
    let localeCenter = this.state.localeCenter;
    
    const initialViewState = {
      longitude: localeCenter.lng,
      latitude: localeCenter.lat,
      zoom: 15
    };

    const {viewstate, map} = this.state;
    const boxLayers = this.genBoxData();
    // const routeLayers = this.genRouteData(false);
    // const routeOutlineLayers = this.genRouteData(true);
    // const iconStartLayers = this.genIconLayer(true);
    // const iconEndLayers = this.genIconLayer(false);
    const pathLayers = this.genPathLayer();

    return (
      <Dialog
        open={this.state.open}
        onClose={this.handleClose}
        fullWidth={true}
        fullHeight={true}
        maxWidth={'lg'}
      >
        <DialogContent>
          <div style={{position:"relative", height:'70vh'}}>
            <DeckGL 
              initialViewState={initialViewState} 
              // viewState={viewState}
              ContextProvider={MapContext.Provider}
              controller={true} height='100%'
              top="50px" position="relative" 
              layers={[boxLayers].concat(pathLayers)}//, routeOutlineLayers, routeLayers, iconStartLayers, iconEndLayers]}
            >
          
                <StaticMap mapStyle={map.style} mapboxApiAccessToken={Config.MBOX_KEY()} attributionControl={false}/>
                <ButtonGroup style={{top:10, left:10, position:"relative"}} size="small" variant="contained" color="primary" aria-label="contained primary button group">
                  <Button color={this.state.map._style=="mono"? "secondary":"primary"} onClick={
                    () => {
                      this.setState({
                        map:{
                          ...this.state.map,
                          style: Config.MBOX_STYLE(Localization.strings.getLanguage()).mono,
                          _style: "mono"
                        }
                      });
                      this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).mono;
                      this.state.map._style = "mono";
                    }
                  }>MONO</Button>
                  <Button color={this.state.map._style=="satellite"? "secondary":"primary"} onClick={
                    () => {
                      this.setState({
                        map:{
                          ...this.state.map,
                          style: Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite,
                          _style: "satellite"
                        }
                      });
                      this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite;
                      this.state.map._style = "satellite";
                    }
                  }>SATELLITE</Button>
                  <Button color={this.state.map._style=="cartoon"? "secondary":"primary"} onClick={
                    () => {
                      this.setState({
                        map:{
                          ...this.state.map,
                          style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
                          _style: "cartoon"
                        }
                      });
                      this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon;
                      this.state.map._style = "cartoon";
                    }
                  }>VECTOR</Button>
                </ButtonGroup>
            </DeckGL>
          </div>
        </DialogContent>
        <DialogActions style={{padding:'16px 24px'}}>
          <Button onClick={this.handleClose}>
            {Localization.strings.CLOSE}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTheme(SubmissionDetailMapDialog);
